export function groupPeaks(peakList, factor = 1) {
    if (peakList && peakList.length === 0)
        return [];
    let peaks = JSON.parse(JSON.stringify(peakList));
    peaks.sort((a, b) => a.x - b.x);
    let previousPeak = {
        x: Number.NEGATIVE_INFINITY,
        y: 0,
        width: 1,
    };
    let currentGroup = [previousPeak];
    let groups = [];
    peaks.forEach((peak) => {
        if ((peak.x - previousPeak.x) / (peak.width + previousPeak.width) <=
            factor / 2) {
            currentGroup.push(peak);
        }
        else {
            currentGroup = [peak];
            groups.push(currentGroup);
        }
        previousPeak = peak;
    });
    return groups;
}
//# sourceMappingURL=groupPeaks.js.map